import { create } from 'zustand';

const OrderFunctionStore = create((set) => ({
    parcelDetailOption: false,
    setParcelDetailOption: (parcelDetailOption) => set({ parcelDetailOption }),
    parcelDetailFirstOption: false,
    setParcelDetailFirstOption: (parcelDetailFirstOption) => set({ parcelDetailFirstOption }),
    parcelDetailOptionError: [],
    setParcelDetailOptionError: (parcelDetailOptionError) => set({ parcelDetailOptionError }),
    parcelDetailSecondOption: false,
    setParcelDetailSecondOption: (parcelDetailSecondOption) => set({ parcelDetailSecondOption }),
}));

export default OrderFunctionStore;